import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import ProportionBar from '../../../../../../shared/components/v3/Charts/ProportionBar/ProportionBar';
import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';

import './TelemedicineData.scss';

export const TelemedicineData = ({ data, inDownloadMode }: { data: IHealthReport; inDownloadMode?: boolean }) => {
  const { t } = useTranslation();

  const proportionBarData = useMemo(() => {
    if (!data?.telemedicineData) return [];
    return data.telemedicineData.map((item) => ({
      label: item.label,
      value: item.value
    }));
  }, [data]);

  return (
    <div className="telemedicine-data-container">
      <div className="health-report-section-subtitle">
        {t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.title)}
      </div>
      <div className="td-info">
        <div className="td-info-item">
          <div className="td-info-value">{data.telemedicineUsersServed}</div>
          <div className="td-info-label">{t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.usersAttended)}</div>
        </div>
        <div className="td-info-item">
          <div className="td-info-value">{data.telemedicineConsultations}</div>
          <div className="td-info-label">{t(TRANSLATIONS_REPORTS.healthReport.telemedicineData.totalSessions)}</div>
        </div>
      </div>
      {proportionBarData.length > 0 && (
        <div className="td-telemedicine-chart">
          <ProportionBar data={proportionBarData} isStatic={inDownloadMode} />
        </div>
      )}
      <BdsDivider size="s" color="high" />
    </div>
  );
};

export default TelemedicineData;
